import { RemoteGetAllActivitiesByStatus } from 'data/usecases';
import { GetAllActivitiesByStatus } from 'domain/usecases';
import { makeApiUrlAllActivitiesByStatus } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllActivitiesByStatus = (): GetAllActivitiesByStatus =>
  new RemoteGetAllActivitiesByStatus(
    makeApiUrlAllActivitiesByStatus(),
    makeAxiosHttpClient(),
  );
